var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('SettingsTopBar',{attrs:{"pathCurrent":"Content","pathBefore":"Settings /","showBackButton":true,"backRoute":_vm.backRoute,"showSubmitButton":false}}),_c('CmsMenu',{attrs:{"menuData":_vm.menuData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }